import React, {useEffect, useState} from "react";

import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";

import HeaderHome from "../../components/layout/HeaderHome";
import FooterOne from "../../components/layout/FooterOne";
import BottomFooter from "../../components/layout/BottomFooter";

const TermsAndCondition = () => {

  return (
    <>
              {/* ColorInit */}
              <ColorInit color={false} />
        
              {/* ScrollToTop */}
              <ScrollToTop smooth color='#990A02' />
        
              {/* Preloader */}
              <Preloader />
        
              {/* HeaderTwo */}
              {/* <HeaderOne /> */}
              <HeaderHome />

        <div className="container-sm">
        <p className="my-30">
1. INTRODUCTION Welcome to the Pink Peony Shop website and mobile application (the “Platform”) operated by ZanDen Technology Pte Ltd (“Pink Peony,” “we,” “us,” or “our”). Pink Peony Shop is a paid service where you (“Seller”, “User”, “you,” or “your”) may engage Pink Peony Shop  on a non-exclusive basis to provide platform and related services as described in these Terms of Service. Please read these Terms of Service carefully before creating an account (“Account”) via our proprietary platform known as the Pink Peony Shop  (“Portal”) so that you are aware of your rights and obligations. <br />
<br />
2. Before becoming a User of the Platform or engaging our Services, you must read and accept all of the terms and conditions in, or linked to, these Terms of Service and you must consent to the processing of your personal data as described in our Privacy Policy. We reserve the right to revise these Terms of Service at any time without providing notice to you. Your continued use of the Platform, the Portal and/or any of our Services after such changes or amendments have been posted shall constitute your acceptance of the revised Terms of Service. If you do not agree to any such changes, you must stop using the Services, the Platform and the Portal, and contact us at hello@pinkpeonyshopsg.com to deactivate your Account upon which these Terms of Service will be terminated. <br />
<br />
3. We reserve the right to (a) refuse to provide you access to the Platform, the Portal, our Services or to allow you to open an Account for any reason; and/or (b) change, modify, suspend or discontinue all or any part of this Platform, the Portal or the Services, temporarily or permanently, at any time or upon notice as required by local laws. We may release certain Services or their features in a beta version, which may not work correctly or in the same way the final version may work, and we shall not be held liable in such instances. We may also impose limits on certain features or restrict your access to any part of the, or the entire, Platform, Portal or Services in our sole discretion and without notice or liability. <br />
<br />
4. In order for you to use the Services, you may be required to register for an Account. You may only create an Account and use our Services if you are located in one of our approved countries, as updated from time to time. To create an Account, you may be required to provide certain personal information including your mobile number, telephone number, email and/or your preferred password. We will only process your registration once you have provided all requested information. Upon successful creation of your Account, you will be provided a unique user identification (“User ID”).  You are only allowed to open a single Account in each approved country and you cannot transfer your Account to any other person. <br />
<br />
5. You are responsible for supplying and authorizing access to your Account to your authorized personnel, and for ensuring that any person operating your Account on your behalf has full power and authority to do so on your behalf. You are fully responsible for all activities that occur under your Account even if such activities or uses were not committed by you. We will not be liable for any loss or damage arising from unauthorized use of your password or your failure to comply with these Terms of Service. <br />
<br />
The license for use of this Site and the Services is effective until terminated. This license will terminate as set forth under these Terms of Service or if you fail to comply with any term or condition of these Terms of Service. In any such event, Shopee may effect such termination with or without notice to you. <br />
<br />
 
6.You agree not to: 
<br />
 
(a) upload, post, transmit or otherwise make available any Content that is unlawful, harmful, threatening, abusive, harassing, alarming, distressing, tortuous, defamatory, vulgar, obscene, libelous, invasive of another's privacy, hateful, or racially, ethnically or otherwise objectionable;
 <br />
(b) violate any laws, including without limitation any laws and regulation in relation to export and import restrictions, third party rights or our Prohibited and Restricted Items policy; 
 <br />

(c) upload, post, transmit or otherwise make available any Content featuring an unsupervised minor or use the Services to harm minors in any way; 
 <br />

(d) use the Services or upload Content to impersonate any person or entity, or otherwise misrepresent your affiliation with a person or entity; 
 <br />

(e) forge headers or otherwise manipulate identifiers in order to disguise the origin of any Content transmitted through the Services; 
 <br />

(f) remove any proprietary notices from the Site; 
 <br />

(g) cause, permit or authorize the modification, creation of derivative works, or translation of the Services without the express permission of Pink Peony; 
 <br />

(h) use the Services for the benefit of any third party or any manner not permitted by the licenses granted herein; 
 <br />

(i) use the Services or upload Content in a manner that is fraudulent, unconscionable, false, misleading or deceptive;
 <br />

(j) open and/or operate multiple user accounts in connection with any conduct that violates either the letter or spirit of these Terms of Service;
 <br />

(k) access the Pink Peony platform, open a user account, or otherwise access your user account using any non-official Pink Peony hardware or software, including but not limited to an emulator, simulator, both or other similar hardware or software; 
<br />
	
(l) attempt to decompile, reverse engineer, disassemble or hack the Services (or any portion thereof), or to defeat or overcome any encryption technology or security measures implemented by Pink Peony with respect to the Services and/or data transmitted; 
 <br />

(m) harvest or collect any information about or regarding other Account holders, including, without limitation, any personal data or information; 
 <br />

(n) upload, email, post, transmit or otherwise make available any Content that you do not have a right to make available under any law or under contractual or fiduciary relationships (such as inside information, proprietary and confidential information learned or disclosed as part of employment relationships or under nondisclosure agreements); 
 <br />

(o) upload, email, post, transmit or otherwise make available any Content that infringes any patent, trademark, trade secret, copyright or other proprietary rights of any party; 
 <br />

(p) upload, email, post, transmit or otherwise make available any unsolicited or unauthorised advertising, promotional materials, "junk mail", "spam", "chain letters", "pyramid schemes", or any other unauthorised form of solicitation; 
<br /><br />


7. Violations of this policy may result in a range of actions, including, without limitation, any or all of the following: <br />

 
⦁ Listing deletion<br />

 
⦁ Limits placed on Account privileges <br />

 
⦁ Account suspension and subsequent termination<br />

 
⦁ Criminal charges <br />

 
⦁ Civil actions, including without limitation a claim for damages and/or interim or injunctive relief
<br />
<br />

8. Overseas Vendor Registration
For Sellers located outside of Singapore selling Digital Services that fall under the scope of the Overseas Vendor Registration Regime ("Overseas Digital Services Seller"), supplies of Digital Services to Buyers (i.e. individuals and non-GST registered businesses) are subject to GST ("OVR GST Amount"). If Buyer is GST registered, the responsibility lies with the GST-registered Buyer to provide his GST registration number to Pink Peony and Seller as evidence that he is indeed GST-registered. With effect from 1 March 2026, the scope of the Overseas Vendor Registration Regime will be extended to include non-digital services that can be supplied and received remotely and low value goods sold by sellers from outside of Singapore. <br />
<br />

 
9. Disputes<br />

9.1 In the event a problem arises in a transaction, such problem shall be resolved according to Pink Peony’s policies. <br />

 
9.2 Each Buyer and Seller covenants and agrees that it will not bring suit or otherwise assert any claim against Pink Peony or its Affiliates (except where Pink Peony or its Affiliates is the Seller of the product that the claim relates to) in relation to any transaction made on the Site or any dispute related to such transaction.
 <br />

 9.3 To be clear, the services provided are only available to Buyers covered under Pink Peony membership. Buyer using other payment means for his/her purchase should contact Seller directly.
<br />
<br />

10.QUESTIONS, CONCERNS OR COMPLAINTS? CONTACT US 
If you have any questions or concerns about this Privacy Policy or our privacy practices, or wish to exercise your rights under applicable Privacy Laws, we welcome you to contact our Data Protection Officer by email at hello@pinkpeonyshopsg.com

        </p>
        </div>
        

        {/* FooterTwo */}
              <FooterOne />
        
              {/* BottomFooter */}
              <BottomFooter />
              
    </>
  );
};

export default TermsAndCondition;